import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import axios from 'axios';
import { injectIntl, FormattedMessage } from 'react-intl';
import { headers } from '../../../actions/defaults';
import { API_URL } from '../../../environment';

const buttonSx = theme => ({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    color: theme.palette.primary.contrastText,
  },
  '&:focus': {
    color: theme.palette.primary.contrastText,
  },
  '&:active': {
    color: theme.palette.primary.contrastText,
  },
});

const StripeOnboardButton = () => {
  const [stripeAccountLink, setStripeAccountLink] = useState(null);

  useEffect(() => {
    axios
      .post(`${API_URL}/clinic_admin/stripe_account_links`, {}, headers())
      .then(response => {
        setStripeAccountLink(response.data.url);
      });
  }, []);

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        href={stripeAccountLink}
        rel="noopener noreferrer"
        sx={buttonSx}
      >
        <FormattedMessage defaultMessage="Go To Stripe" />
      </Button>
    </div>
  );
};

export default injectIntl(StripeOnboardButton);
